import React, { useEffect, useRef, useState } from "react";
import { getApiCall, postApiCall, postFormApiCall } from "../../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../../component/MaterialIcon";
import {
  Box,
  Modal,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import {
  Add,
  CheckCircleOutline,
  CloudDownloadOutlined,
  Delete,
  DeleteOutline,
  Edit,
  StoreOutlined,
  VideoLabel,
  ViewColumn,
  Visibility,
} from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import {
  Button,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import TextComponent from "../../component/mcqComponent/TextComponent";
import LinkComponent from "../../component/mcqComponent/LinkComponent";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import ViewQuestionData from "./ViewQuestionData";
import DisplayEnteredData from "./DisplayTheEnteredData";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const addStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "97%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  maxHeight: "calc(100vh - 100px)",
  overflowY: "auto",
};

const typeList = [
  { id: "1", value: "Text" },
  { id: "2", value: "Link" },
  { id: "3", value: "Text/Image" },
];
const answersList = [
  { id: "A", value: "Option A" },
  { id: "B", value: "Option B" },
  { id: "C", value: "Option C" },
  { id: "D", value: "Option D" },
];
const trueFalseAnswersList = [
  { id: "A", value: "Option A" },
  { id: "B", value: "Option B" },
];

const Questions = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const [boardName, setBoardName] = useState("");
  const [languageName, setLanguageName] = useState("");

  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState("");
  const [moduleList, setModuleList] = useState([]);
  const [moduleName, setModuleName] = useState("");
  const [questionTypesList, setQuestionTypesList] = useState([]);
  const [questionTypesName, setQuestionTypesName] = useState("");
  const [priority, setPriority] = useState("");

  const [levelList, setLevelList] = useState([]);
  const [levelName, setLevelName] = useState("");

  const [duration, setDuration] = useState("");

  const [mcqId, setMcqId] = useState("");

  const [excelData, setExcelData] = useState([]);
  const [excelFile, setExcelFile] = useState(null);

  // Main Values
  const [questions, setQuestions] = useState([]);

  //   type and values
  const [questionType, setQuestionType] = useState("");
  const [questionTextValueEnglish, setQuestionTextValueEnglish] = useState("");
  const [questionLinkValueEnglish, setQuestionLinkValueEnglish] = useState("");
  const [questionTextValueHindi, setQuestionTextValueHindi] = useState("");
  const [questionLinkValueHindi, setQuestionLinkValueHindi] = useState("");
  const [questionTextValueMarathi, setQuestionTextValueMarathi] = useState("");
  const [questionLinkValueMarathi, setQuestionLinkValueMarathi] = useState("");

  const [option1Type, setOption1Type] = useState("");
  const [option1TextValueEnglish, setOption1TextValueEnglish] = useState("");
  const [option1LinkValueEnglish, setOption1LinkValueEnglish] = useState("");
  const [option1TextValueHindi, setOption1TextValueHindi] = useState("");
  const [option1LinkValueHindi, setOption1LinkValueHindi] = useState("");
  const [option1TextValueMarathi, setOption1TextValueMarathi] = useState("");
  const [option1LinkValueMarathi, setOption1LinkValueMarathi] = useState("");

  const [option2Type, setOption2Type] = useState("");
  const [option2TextValueEnglish, setOption2TextValueEnglish] = useState("");
  const [option2LinkValueEnglish, setOption2LinkValueEnglish] = useState("");
  const [option2TextValueHindi, setOption2TextValueHindi] = useState("");
  const [option2LinkValueHindi, setOption2LinkValueHindi] = useState("");
  const [option2TextValueMarathi, setOption2TextValueMarathi] = useState("");
  const [option2LinkValueMarathi, setOption2LinkValueMarathi] = useState("");

  const [option3Type, setOption3Type] = useState("");
  const [option3TextValueEnglish, setOption3TextValueEnglish] = useState("");
  const [option3LinkValueEnglish, setOption3LinkValueEnglish] = useState("");
  const [option3TextValueHindi, setOption3TextValueHindi] = useState("");
  const [option3LinkValueHindi, setOption3LinkValueHindi] = useState("");
  const [option3TextValueMarathi, setOption3TextValueMarathi] = useState("");
  const [option3LinkValueMarathi, setOption3LinkValueMarathi] = useState("");

  const [option4Type, setOption4Type] = useState("");
  const [option4TextValueEnglish, setOption4TextValueEnglish] = useState("");
  const [option4LinkValueEnglish, setOption4LinkValueEnglish] = useState("");
  const [option4TextValueHindi, setOption4TextValueHindi] = useState("");
  const [option4LinkValueHindi, setOption4LinkValueHindi] = useState("");
  const [option4TextValueMarathi, setOption4TextValueMarathi] = useState("");
  const [option4LinkValueMarathi, setOption4LinkValueMarathi] = useState("");

  const [answerValue, setAnswerValue] = useState("");
  const [tagName, setTagName] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  const formRef = useRef();
  const fetchData = async () => {
    // setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);
    const qtypes = await getApiCall("questiontypes/get-all");
    setQuestionTypesList(qtypes.data);

    const response = await getApiCall("questions/get-all-questions");
    setData(response.data);
    response.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const [isTrueFalse, setIsTrueFalse] = useState(false);
  const [isMatchFollowing, setIsMatchFollowing] = useState(false);
  const onQuestionTypeChange = async (val) => {
    setOption1TextValueEnglish("");
    setOption2TextValueEnglish("");
    setOption3TextValueEnglish("");
    setOption4TextValueEnglish("");
    setOption1Type("");
    setOption2Type("");
    setOption3Type("");
    setOption4Type("");
    setIsTrueFalse(false);
    setIsMatchFollowing(false);
    if (val === "3") {
      setIsTrueFalse(true);
      setOption1Type("1");
      setOption2Type("1");

      setOption1TextValueEnglish("TRUE");
      setOption2TextValueEnglish("FALSE");
      setOption3TextValueEnglish("");
      setOption4TextValueEnglish("");
    }
    if (val === "4") {
      setIsMatchFollowing(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const formData = new FormData();
    // formData.append("question_type_id", questionTypesName);
    formData.append("module_id", moduleName);
    formData.append("class_id", className);
    formData.append("isTrueFalse", isTrueFalse);
    formData.append("duration", duration);
    formData.append("questionId", mcqId);
    formData.append("priority", priority);

    if (mcqId === "") {
      if (questions.length === 0) {
        setLoading(false);
        return Swal.fire({
          title: "Error",
          text: "Add Question",
          icon: "error",
        });
      }
      formData.append("questions", JSON.stringify(questions));
    } else {
      // Question Type
      formData.append("question_type_id", questionTypesName);
      formData.append("question_type", questionType);
      formData.append("question_type_text_english", questionTextValueEnglish);
      formData.append("question_type_link_english", questionLinkValueEnglish);
      formData.append("question_type_text_hindi", questionTextValueHindi);
      formData.append("question_type_link_hindi", questionLinkValueHindi);
      formData.append("question_type_text_marathi", questionTextValueMarathi);
      formData.append("question_type_link_marathi", questionLinkValueMarathi);

      // Option 1
      formData.append("option_a_type", option1Type);
      formData.append("option_a_type_text_english", option1TextValueEnglish);
      formData.append("option_a_type_link_english", option1LinkValueEnglish);
      formData.append("option_a_type_text_hindi", option1TextValueHindi);
      formData.append("option_a_type_link_hindi", option1LinkValueHindi);
      formData.append("option_a_type_text_marathi", option1TextValueMarathi);
      formData.append("option_a_type_link_marathi", option1LinkValueMarathi);

      // Option 2
      formData.append("option_b_type", option2Type);
      formData.append("option_b_type_text_english", option2TextValueEnglish);
      formData.append("option_b_type_link_english", option2LinkValueEnglish);
      formData.append("option_b_type_text_hindi", option2TextValueHindi);
      formData.append("option_b_type_link_hindi", option2LinkValueHindi);
      formData.append("option_b_type_text_marathi", option2TextValueMarathi);
      formData.append("option_b_type_link_marathi", option2LinkValueMarathi);

      // Option 3
      formData.append("option_c_type", option3Type);
      formData.append("option_c_type_text_english", option3TextValueEnglish);
      formData.append("option_c_type_link_english", option3LinkValueEnglish);
      formData.append("option_c_type_text_hindi", option3TextValueHindi);
      formData.append("option_c_type_link_hindi", option3LinkValueHindi);
      formData.append("option_c_type_text_marathi", option3TextValueMarathi);
      formData.append("option_c_type_link_marathi", option3LinkValueMarathi);

      // Option 4
      formData.append("option_d_type", option4Type);
      formData.append("option_d_type_text_english", option4TextValueEnglish);
      formData.append("option_d_type_link_english", option4LinkValueEnglish);
      formData.append("option_d_type_text_hindi", option4TextValueHindi);
      formData.append("option_d_type_link_hindi", option4LinkValueHindi);
      formData.append("option_d_type_text_marathi", option4TextValueMarathi);
      formData.append("option_d_type_link_marathi", option4LinkValueMarathi);

      // Answer
      formData.append("answer", answerValue);
    }
    let res = {};
    if (mcqId === "") {
      res = await postFormApiCall("questions/add", formData);
    } else {
      res = await postFormApiCall("questions/update", formData);
    }

    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    setMcqId("");
    setDuration("");
    setQuestions([]);
    setQuestionTypesName("");
    setClassName("");
    setModuleName("");
    // setModuleList([]);
    // setLevelList([]);
    setTagName("");
    setPriority("");
    setIsTypeQuestionText(false);
    setIsTypeQuestionLink(false);

    setIsTypeOption1Text(false);
    setIsTypeOption1Link(false);

    setIsTypeOption2Text(false);
    setIsTypeOption2Link(false);

    setIsTypeOption3Text(false);
    setIsTypeOption3Link(false);

    setIsTypeOption4Text(false);
    setIsTypeOption4Link(false);

    setIsQuestionType(false);
    setIsOption1Type(false);
    setIsOption2Type(false);
    setIsOption3Type(false);
    setIsOption4Type(false);

    setQuestionType("");
    setQuestionTextValueEnglish("");
    setQuestionLinkValueEnglish("");
    setQuestionTextValueHindi("");
    setQuestionLinkValueHindi("");
    setQuestionTextValueMarathi("");
    setQuestionLinkValueMarathi("");

    setOption1Type("");
    setOption1TextValueEnglish("");
    setOption1LinkValueEnglish("");
    setOption1TextValueHindi("");
    setOption1LinkValueHindi("");
    setOption1TextValueMarathi("");
    setOption1LinkValueMarathi("");

    setOption2Type("");
    setOption2TextValueEnglish("");
    setOption2LinkValueEnglish("");
    setOption2TextValueHindi("");
    setOption2LinkValueHindi("");
    setOption2TextValueMarathi("");
    setOption2LinkValueMarathi("");

    setOption3Type("");
    setOption3TextValueEnglish("");
    setOption3LinkValueEnglish("");
    setOption3TextValueHindi("");
    setOption3LinkValueHindi("");
    setOption3TextValueMarathi("");
    setOption3LinkValueMarathi("");

    setOption4Type("");
    setOption4TextValueEnglish("");
    setOption4LinkValueEnglish("");
    setOption4TextValueHindi("");
    setOption4LinkValueHindi("");
    setOption4TextValueMarathi("");
    setOption4LinkValueMarathi("");

    fetchData();
  };

  const handleFileUpload = (e) => {
    setExcelFile(e.target.files[0]);

    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
      setExcelData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  const onClassChange = async (val) => {
    setLoading(true);
    const classData = await postApiCall("module/get-by-class", { id: val });
    setModuleList(classData.data);
    setLoading(false);
  };
  // const onModuleChange = async (val) => {
  //   setLoading(true);
  //   const leveRes = await postApiCall("levels/get-by-module", { id: val });
  //   setLevelList(leveRes.data);
  //   setLoading(false);
  // };

  const [isTypeQuestionText, setIsTypeQuestionText] = useState(false);
  const [isTypeQuestionLink, setIsTypeQuestionLink] = useState(false);

  const [isTypeOption1Text, setIsTypeOption1Text] = useState(false);
  const [isTypeOption1Link, setIsTypeOption1Link] = useState(false);

  const [isTypeOption2Text, setIsTypeOption2Text] = useState(false);
  const [isTypeOption2Link, setIsTypeOption2Link] = useState(false);

  const [isTypeOption3Text, setIsTypeOption3Text] = useState(false);
  const [isTypeOption3Link, setIsTypeOption3Link] = useState(false);

  const [isTypeOption4Text, setIsTypeOption4Text] = useState(false);
  const [isTypeOption4Link, setIsTypeOption4Link] = useState(false);

  const [isQuestionType, setIsQuestionType] = useState(false);
  const [isOption1Type, setIsOption1Type] = useState(false);
  const [isOption2Type, setIsOption2Type] = useState(false);
  const [isOption3Type, setIsOption3Type] = useState(false);
  const [isOption4Type, setIsOption4Type] = useState(false);

  const onTypeChange = async (typeVal, val) => {
    if (typeVal == "1") {
      if (val == "Q") {
        setIsTypeQuestionText(true);
        setIsTypeQuestionLink(false);
        setIsQuestionType(true);
        setQuestionLinkValueEnglish("");
        setQuestionTextValueEnglish("");
        setQuestionLinkValueHindi("");
        setQuestionTextValueHindi("");
        setQuestionLinkValueMarathi("");
        setQuestionTextValueMarathi("");
      }
      if (val == "O1") {
        setIsTypeOption1Link(false);
        setIsTypeOption1Text(true);
        setIsOption1Type(true);
        setOption1LinkValueEnglish("");
        setOption1TextValueEnglish("");
        setOption1LinkValueHindi("");
        setOption1TextValueHindi("");
        setOption1LinkValueMarathi("");
        setOption1TextValueMarathi("");
      }
      if (val == "O2") {
        setIsTypeOption2Link(false);
        setIsTypeOption2Text(true);
        setIsOption2Type(true);
        setOption2LinkValueEnglish("");
        setOption2TextValueEnglish("");
        setOption2LinkValueHindi("");
        setOption2TextValueHindi("");
        setOption2LinkValueMarathi("");
        setOption2TextValueMarathi("");
      }
      if (val == "O3") {
        setIsTypeOption3Link(false);
        setIsTypeOption3Text(true);
        setIsOption3Type(true);
        setOption3LinkValueEnglish("");
        setOption3TextValueEnglish("");
        setOption3LinkValueHindi("");
        setOption3TextValueHindi("");
        setOption3LinkValueMarathi("");
        setOption3TextValueMarathi("");
      }
      if (val == "O4") {
        setIsTypeOption4Link(false);
        setIsTypeOption4Text(true);
        setIsOption4Type(true);
        setOption4LinkValueEnglish("");
        setOption4TextValueEnglish("");
        setOption4LinkValueHindi("");
        setOption4TextValueHindi("");
        setOption4LinkValueMarathi("");
        setOption4TextValueMarathi("");
      }
    } else if (typeVal == "2") {
      if (val == "Q") {
        setIsTypeQuestionText(false);
        setIsTypeQuestionLink(true);
        setIsQuestionType(true);
        setQuestionLinkValueEnglish("");
        setQuestionTextValueEnglish("");
        setQuestionLinkValueHindi("");
        setQuestionTextValueHindi("");
        setQuestionLinkValueMarathi("");
        setQuestionTextValueMarathi("");
      }

      if (val == "O1") {
        setIsTypeOption1Text(false);
        setIsTypeOption1Link(true);
        setIsOption1Type(true);
        setOption1LinkValueEnglish("");
        setOption1TextValueEnglish("");
        setOption1LinkValueHindi("");
        setOption1TextValueHindi("");
        setOption1LinkValueMarathi("");
        setOption1TextValueMarathi("");
      }
      if (val == "O2") {
        setIsTypeOption2Text(false);
        setIsTypeOption2Link(true);
        setIsOption2Type(true);
        setOption2LinkValueEnglish("");
        setOption2TextValueEnglish("");
        setOption2LinkValueHindi("");
        setOption2TextValueHindi("");
        setOption2LinkValueMarathi("");
        setOption2TextValueMarathi("");
      }
      if (val == "O3") {
        setIsTypeOption3Text(false);
        setIsTypeOption3Link(true);
        setIsOption3Type(true);
        setOption3LinkValueEnglish("");
        setOption3TextValueEnglish("");
        setOption3LinkValueHindi("");
        setOption3TextValueHindi("");
        setOption3LinkValueMarathi("");
        setOption3TextValueMarathi("");
      }
      if (val == "O4") {
        setIsTypeOption4Text(false);
        setIsTypeOption4Link(true);
        setIsOption4Type(true);
        setOption4LinkValueEnglish("");
        setOption4TextValueEnglish("");
        setOption4LinkValueHindi("");
        setOption4TextValueHindi("");
        setOption4LinkValueMarathi("");
        setOption4TextValueMarathi("");
      }
    } else if (typeVal == "3") {
      if (val == "Q") {
        setIsTypeQuestionText(true);
        setIsTypeQuestionLink(true);
        setIsQuestionType(true);
        setQuestionLinkValueEnglish("");
        setQuestionTextValueEnglish("");
        setQuestionLinkValueHindi("");
        setQuestionTextValueHindi("");
        setQuestionLinkValueMarathi("");
        setQuestionTextValueMarathi("");
      }
      if (val == "O1") {
        setIsTypeOption1Link(true);
        setIsTypeOption1Text(true);
        setIsOption1Type(true);
        setOption1LinkValueEnglish("");
        setOption1TextValueEnglish("");
        setOption1LinkValueHindi("");
        setOption1TextValueHindi("");
        setOption1LinkValueMarathi("");
        setOption1TextValueMarathi("");
      }
      if (val == "O2") {
        setIsTypeOption2Link(true);
        setIsTypeOption2Text(true);
        setIsOption2Type(true);
        setOption2LinkValueEnglish("");
        setOption2TextValueEnglish("");
        setOption2LinkValueHindi("");
        setOption2TextValueHindi("");
        setOption2LinkValueMarathi("");
        setOption2TextValueMarathi("");
      }
      if (val == "O3") {
        setIsTypeOption3Link(true);
        setIsTypeOption3Text(true);
        setIsOption3Type(true);
        setOption3LinkValueEnglish("");
        setOption3TextValueEnglish("");
        setOption3LinkValueHindi("");
        setOption3TextValueHindi("");
        setOption3LinkValueMarathi("");
        setOption3TextValueMarathi("");
      }
      if (val == "O4") {
        setIsTypeOption4Link(true);
        setIsTypeOption4Text(true);
        setIsOption4Type(true);
        setOption4LinkValueEnglish("");
        setOption4TextValueEnglish("");
        setOption4LinkValueHindi("");
        setOption4TextValueHindi("");
        setOption4LinkValueMarathi("");
        setOption4TextValueMarathi("");
      }
    }
  };
  // useEffect(() => {
  //   console.log(questions);
  // }, [questions]);
  const handleSetButton = () => {
    // setIsQuestionAdded(true)
    if (className === "" || moduleName === "" || questionTypesName === "") {
      return Swal.fire({
        title: "Error",
        text: "Select Class, Module and Question Type",
        icon: "error",
      });
    }

    const newQuestion = {
      questionType: [
        {
          question_type: questionType,
        },
      ],
      questionEnglish: [
        {
          question_type_text: questionTextValueEnglish,
          question_type_link: questionLinkValueEnglish,
        },
      ],
      questionHindi: [
        {
          question_type_text: questionTextValueHindi,
          question_type_link: questionLinkValueHindi,
        },
      ],
      questionMarathi: [
        {
          question_type_text: questionTextValueMarathi,
          question_type_link: questionLinkValueMarathi,
        },
      ],
      options: [
        {
          option1_type: option1Type,
          option1_type_text_english: option1TextValueEnglish,
          option1_type_link_english: option1LinkValueEnglish,
          option1_type_text_hindi: option1TextValueHindi,
          option1_type_link_hindi: option1LinkValueHindi,
          option1_type_text_marathi: option1TextValueMarathi,
          option1_type_link_marathi: option1LinkValueMarathi,
        },
        {
          option2_type: option2Type,
          option2_type_text_english: option2TextValueEnglish,
          option2_type_link_english: option2LinkValueEnglish,
          option2_type_text_hindi: option2TextValueHindi,
          option2_type_link_hindi: option2LinkValueHindi,
          option2_type_text_marathi: option2TextValueMarathi,
          option2_type_link_marathi: option2LinkValueMarathi,
        },
        {
          option3_type: option3Type,
          option3_type_text_english: option3TextValueEnglish,
          option3_type_link_english: option3LinkValueEnglish,
          option3_type_text_hindi: option3TextValueHindi,
          option3_type_link_hindi: option3LinkValueHindi,
          option3_type_text_marathi: option3TextValueMarathi,
          option3_type_link_marathi: option3LinkValueMarathi,
        },
        {
          option4_type: option4Type,
          option4_type_text_english: option4TextValueEnglish,
          option4_type_link_english: option4LinkValueEnglish,
          option4_type_text_hindi: option4TextValueHindi,
          option4_type_link_hindi: option4LinkValueHindi,
          option4_type_text_marathi: option4TextValueMarathi,
          option4_type_link_marathi: option4LinkValueMarathi,
        },
      ],
      answer: answerValue,
      tags: tagName,
      question_type_id: questionTypesName,
    };
    console.log("NEW QUESTIOn", newQuestion);

    setQuestions([...questions, newQuestion]);
    setAnswerValue("");
    setTagName("");

    // setQuestionType("");
    // setQuestionLinkValueEnglish("");
    // setQuestionTextValueEnglish("");
    // setQuestionLinkValueHindi("");
    // setQuestionTextValueHindi("");
    // setQuestionLinkValueMarathi("");
    // setQuestionTextValueMarathi("");

    // setOption1Type("");
    // setOption1TextValueEnglish("");
    // setOption1LinkValueEnglish("");
    // setOption1TextValueHindi("");
    // setOption1LinkValueHindi("");
    // setOption1TextValueMarathi("");
    // setOption1LinkValueMarathi("");

    // setOption2Type("");
    // setOption2TextValueEnglish("");
    // setOption2LinkValueEnglish("");
    // setOption2TextValueHindi("");
    // setOption2LinkValueHindi("");
    // setOption2TextValueMarathi("");
    // setOption2LinkValueMarathi("");

    // setOption3Type("");
    // setOption3TextValueEnglish("");
    // setOption3LinkValueEnglish("");
    // setOption3TextValueHindi("");
    // setOption3LinkValueHindi("");
    // setOption3TextValueMarathi("");
    // setOption3LinkValueMarathi("");

    // setOption4Type("");
    // setOption4TextValueEnglish("");
    // setOption4LinkValueEnglish("");
    // setOption4TextValueHindi("");
    // setOption4LinkValueHindi("");
    // setOption4TextValueMarathi("");
    // setOption4LinkValueMarathi("");

    // setAnswerValue("");

    // setIsQuestionType(false);
    // setIsOption1Type(false);
    // setIsOption2Type(false);
    // setIsOption3Type(false);
    // setIsOption4Type(false);
  };

  const columns = [
    {
      title: "Sl. no",
      field: "serial",
      cellStyle: {
        width: "5%",
      },
    },
    { title: "Module", field: "module_name" },
    { title: "Question", field: "question_type_text_english" },
    {
      title: "Class",
      field: "name",
      cellStyle: {
        width: "10%",
      },
      render: (rowData) => {
        return <>Class {rowData.name}</>;
      },
    },
    { title: "tags", field: "tags" },
    {
      title: "Type",
      field: "duration",
      render: (rowData) => {
        return (
          <>
            {rowData.question_type_id == '1' ? "MCQ" :( rowData.question_type_id == '2' ? "Fill in the blanks" : ( rowData.question_type_id == '3' ? "True/False" : "Match the Following"))}
          </>
        );
      },
    },
    {
      title: "Duration/Score",
      field: "duration",
      render: (rowData) => {
        return (
          <>
            Score: {rowData.score}
            <br />
            Duration: {rowData.duration} min
          </>
        );
      },
    },
    // { title: "Level", field: "level_name" },
  ];

  // const handleFilter = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const formData = new FormData(formRef.current);
  //   const entries = Array.from(formData.entries());
  //   const formValues = entries.reduce(
  //     (prev, [name, value]) => ({
  //       ...prev,
  //       [name]: value,
  //     }),
  //     {}
  //   );

  //   const res = await postApiCall("mcq/get/macqByBoardLanguageAndClass", {
  //     ...formValues,
  //     set_for: filterSelectedTypeFor,
  //   });
  //   setLoading(false);
  //   if (res.error === true) {
  //     return Swal.fire({
  //       title: "Error",
  //       text: res.message,
  //       icon: "error",
  //     });
  //   }

  //   setData(res.data);
  //   res.data.forEach((data, index) => {
  //     data.serial = index + 1;
  //   });
  // };

  const handleEditSetButton = () => {
    const newQuestion = {
      questionType: [
        {
          question_type: questionType,
        },
      ],
      questionEnglish: [
        {
          question_type_text: questionTextValueEnglish,
          question_type_link: questionLinkValueEnglish,
        },
      ],
      questionHindi: [
        {
          question_type_text: questionTextValueHindi,
          question_type_link: questionLinkValueHindi,
        },
      ],
      questionMarathi: [
        {
          question_type_text: questionTextValueMarathi,
          question_type_link: questionLinkValueMarathi,
        },
      ],
      options: [
        {
          option1_type: option1Type,
          option1_type_text_english: option1TextValueEnglish,
          option1_type_link_english: option1LinkValueEnglish,
          option1_type_text_hindi: option1TextValueHindi,
          option1_type_link_hindi: option1LinkValueHindi,
          option1_type_text_marathi: option1TextValueMarathi,
          option1_type_link_marathi: option1LinkValueMarathi,
        },
        {
          option2_type: option2Type,
          option2_type_text_english: option2TextValueEnglish,
          option2_type_link_english: option2LinkValueEnglish,
          option2_type_text_hindi: option2TextValueHindi,
          option2_type_link_hindi: option2LinkValueHindi,
          option2_type_text_marathi: option2TextValueMarathi,
          option2_type_link_marathi: option2LinkValueMarathi,
        },
        {
          option3_type: option3Type,
          option3_type_text_english: option3TextValueEnglish,
          option3_type_link_english: option3LinkValueEnglish,
          option3_type_text_hindi: option3TextValueHindi,
          option3_type_link_hindi: option3LinkValueHindi,
          option3_type_text_marathi: option3TextValueMarathi,
          option3_type_link_marathi: option3LinkValueMarathi,
        },
        {
          option4_type: option4Type,
          option4_type_text_english: option4TextValueEnglish,
          option4_type_link_english: option4LinkValueEnglish,
          option4_type_text_hindi: option4TextValueHindi,
          option4_type_link_hindi: option4LinkValueHindi,
          option4_type_text_marathi: option4TextValueMarathi,
          option4_type_link_marathi: option4LinkValueMarathi,
        },
      ],
      answer: answerValue,
      tags: tagName,
      question_type_id: questionTypesName,
    };
    console.log("NEW QUESTIOn", newQuestion);

    setQuestions([...questions, newQuestion]);
  };
  const handleEdit = async (rowData) => {
    setMcqId(rowData.id);

    setQuestionType("");
    setIsQuestionType(false);

    // empty it first
    setQuestionTextValueEnglish("");
    setQuestionLinkValueEnglish("");
    setQuestionTextValueHindi("");
    setQuestionLinkValueHindi("");
    setQuestionTextValueMarathi("");
    setQuestionLinkValueMarathi("");

    setOption1Type("");
    setIsOption1Type(false);
    setOption1TextValueEnglish("");
    setOption1LinkValueEnglish("");
    setOption1TextValueHindi("");
    setOption1LinkValueHindi("");
    setOption1TextValueMarathi("");
    setOption1LinkValueMarathi("");

    setOption2Type("");
    setIsOption2Type(false);
    setOption2TextValueEnglish("");
    setOption2LinkValueEnglish("");
    setOption2TextValueHindi("");
    setOption2LinkValueHindi("");
    setOption2TextValueMarathi("");
    setOption2LinkValueMarathi("");

    setOption3Type("");
    setIsOption3Type(false);
    setOption3TextValueEnglish("");
    setOption3LinkValueEnglish("");
    setOption3TextValueHindi("");
    setOption3LinkValueHindi("");
    setOption3TextValueMarathi("");
    setOption3LinkValueMarathi("");

    setOption4Type("");
    setIsOption4Type(false);
    setOption4TextValueEnglish("");
    setOption4LinkValueEnglish("");
    setOption4TextValueHindi("");
    setOption4LinkValueHindi("");
    setOption4TextValueMarathi("");
    setOption4LinkValueMarathi("");

    setAnswerValue("");

    // set the value again
    setClassName(rowData.class_id);
    onClassChange(rowData.class_id);
    setModuleName(rowData.module_id);
    setDuration(rowData.duration);
    setPriority(rowData.priority);
    setQuestionTypesName(rowData.question_type_id);
    setTagName(rowData.tags);

    setIsQuestionType(true);

    onTypeChange(rowData.question_type, "Q");

    setQuestionType(rowData.question_type);
    setQuestionTextValueEnglish(rowData.question_type_text_english);
    setQuestionLinkValueEnglish(rowData.question_type_link_english);
    setQuestionTextValueHindi(rowData.question_type_text_hindi);
    setQuestionLinkValueHindi(rowData.question_type_link_hindi);
    setQuestionTextValueMarathi(rowData.question_type_text_marathi);
    setQuestionLinkValueMarathi(rowData.question_type_link_marathi);

    setIsOption1Type(true);
    setOption1Type(rowData.option_a_type);
    onTypeChange(rowData.option_a_type, "O1");
    setOption1TextValueEnglish(rowData.option_a_type_text_english);
    setOption1LinkValueEnglish(rowData.option_a_type_link_english);
    setOption1TextValueHindi(rowData.option_a_type_text_hindi);
    setOption1LinkValueHindi(rowData.option_a_type_link_hindi);
    setOption1TextValueMarathi(rowData.option_a_type_text_marathi);
    setOption1LinkValueMarathi(rowData.option_a_type_link_marathi);

    setIsOption2Type(true);
    setOption2Type(rowData.option_b_type);
    onTypeChange(rowData.option_b_type, "O2");
    setOption2TextValueEnglish(rowData.option_b_type_text_english);
    setOption2LinkValueEnglish(rowData.option_b_type_link_english);
    setOption2TextValueHindi(rowData.option_b_type_text_hindi);
    setOption2LinkValueHindi(rowData.option_b_type_link_hindi);
    setOption2TextValueMarathi(rowData.option_b_type_text_marathi);
    setOption2LinkValueMarathi(rowData.option_b_type_link_marathi);

    setIsOption3Type(true);
    setOption3Type(rowData.option_c_type);
    onTypeChange(rowData.option_c_type, "O3");
    setOption3TextValueEnglish(rowData.option_c_type_text_english);
    setOption3LinkValueEnglish(rowData.option_c_type_link_english);
    setOption3TextValueHindi(rowData.option_c_type_text_hindi);
    setOption3LinkValueHindi(rowData.option_c_type_link_hindi);
    setOption3TextValueMarathi(rowData.option_c_type_text_marathi);
    setOption3LinkValueMarathi(rowData.option_c_type_link_marathi);

    setIsOption4Type(true);
    setOption4Type(rowData.option_d_type);
    onTypeChange(rowData.option_d_type, "O4");
    setOption4TextValueEnglish(rowData.option_d_type_text_english);
    setOption4LinkValueEnglish(rowData.option_d_type_link_english);
    setOption4TextValueHindi(rowData.option_d_type_text_hindi);
    setOption4LinkValueHindi(rowData.option_d_type_link_hindi);
    setOption4TextValueMarathi(rowData.option_d_type_text_marathi);
    setOption4LinkValueMarathi(rowData.option_d_type_link_marathi);

    setAnswerValue(rowData.answer);

    // setMcqView(false);
    // setQuestions([]);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // inputRef.current.focus();
    // const input = document.getElementById("editpanel");
    // input.classList.add("glow");
    // input.focus();
    // setTimeout(() => {
    //   input.classList.remove("glow");
    // }, 2000);
  };

  const handleDelete = async (id) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("question/delete-by-id", { id: id });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  const [mcqView, setMcqView] = useState(false);
  const [viewDeleteId, setViewDeleteId] = useState("");
  const viewSetQuestions = async (ids) => {
    setMcqView(true);

    setLoading(true);
    setViewDeleteId(ids);
    const res = await postApiCall("mcq/get/mcqQuestionBySetId", { id: ids });
    if (res.error === true) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    setLoading(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    let temp = [];
    for (let val of res.data) {
      // console.log("val", typeof (val.option1_type));
      const newQuestion = {
        question: [
          {
            question_type: val.question_type.toString(),
            question_type_text: val.question_type_text,
            question_type_link: val.question_type_link,
          },
        ],
        options: [
          {
            option1_type: val.option1_type.toString(),
            option1_type_text: val.option1_type_text,
            option1_type_link: val.option1_type_link,
          },
          {
            option2_type: val.option2_type.toString(),
            option2_type_text: val.option2_type_text,
            option2_type_link: val.option2_type_link,
          },
          {
            option3_type: val.option3_type.toString(),
            option3_type_text: val.option3_type_text,
            option3_type_link: val.option3_type_link,
          },
          {
            option4_type: val.option4_type.toString(),
            option4_type_text: val.option4_type_text,
            option4_type_link: val.option4_type_link,
          },
        ],
        answer: val.answer,
        question_id: val.id,
        tags: val.tags,
      };
      temp.push(newQuestion);
      // setQuestions([...questions, newQuestion]);
    }
    setQuestions(temp);
  };
  const [viewOpen, setViewOpen] = useState(false);
  const [viewQData, setViewQData] = useState(null);
  const viewData = async (data) => {
    setViewQData(data);
    setViewOpen(true);
  };

  const handleClose = () => {
    setViewOpen(false);
    setViewQData(null);
  };

  const [filterSelectedTypeFor, setFilterSlectedTypeFor] = useState("");
  async function filterTypeOnChange(val) {
    setLoading(true);
    const res = await postApiCall("mcq/get/all", { set_for: val });
    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  }

  //question delete
  const deleteQuestion = async (val) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const res = await postApiCall("mcq/delete", { id: val });
        if (res.error === true) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        setLoading(false);
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        viewSetQuestions(viewDeleteId);
      }
    });
  };

  // delete from set
  const handleDeleteQuestion = (indexToDelete) => {
    const updated = [...questions];
    updated.splice(indexToDelete, 1); // remove 1 element at index
    setQuestions(updated);
  };

  return (
    <>
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
      {/* view Question modal */}
      <ViewQuestionData
        open={viewOpen}
        handleClose={handleClose}
        data={viewQData}
      />

      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Questions</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Questions</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {mcqId === "" ? "Add" : "Edit"} Questions
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {mcqId === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                onClassChange(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {mcqId === "" ? "Select" : "Edit"} Module
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setModuleName(e.target.value);
                                // onModuleChange(e.target.value);
                              }}
                              required
                              value={moduleName}
                              name="module_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {moduleList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.module_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {mcqId === "" ? "Select" : "Edit"} Priority
                            </label>
                            <select
                              className="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => setPriority(e.target.value)}
                              required
                              value={priority}
                              name="priority"
                            >
                              <option value="" disabled>
                                Select an option
                              </option>
                              {Array.from({ length: 20 }, (_, i) => i + 1).map(
                                (num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        {/* <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {mcqId === "" ? "Select" : "Edit"} Select Level
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setLevelName(e.target.value);
                              }}
                              required
                              value={levelName}
                              name="level_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {levelList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div> */}

                        {/* duration */}
                        <div className="col-md-3 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {mcqId === "" ? "Add" : "Edit"} Duration(in
                              minutes)
                            </label>
                            <input
                              type="number"
                              onChange={(e) => setDuration(e.target.value)}
                              className="form-control"
                              placeholder="in minute"
                              ref={inputRef}
                              value={duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <hr
                            style={{
                              margin: "20px 0",
                              borderTop: "1px solid #ccc",
                            }}
                          />
                        </div>
                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {mcqId === "" ? "Select" : "Edit"} Question Type
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setQuestionTypesName(e.target.value);
                                onQuestionTypeChange(e.target.value);
                              }}
                              required
                              value={questionTypesName}
                              name="question_type_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {questionTypesList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {mcqId === "" ? "Add" : "Edit"} Tags for each
                              {/* questions (separated by coma) */}
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setTagName(e.target.value)}
                              className="form-control"
                              placeholder="Eg: traffic, rules"
                              ref={inputRef}
                              value={tagName}
                            />
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <h4 id="editpanel" ref={inputRef}>
                            Question
                          </h4>
                        </div>
                        {/* questions insert */}
                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Type</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setQuestionType(e.target.value);
                                onTypeChange(e.target.value, "Q");
                              }}
                              value={questionType}
                            >
                              <option value="" disabled selected>
                                select type
                              </option>
                              {typeList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {isQuestionType && (
                          <div className="col-md-12 col-sm-12">
                            <div className="col-md-12 col-sm-12">
                              <h6 id="editpanel">English</h6>
                            </div>
                            {isTypeQuestionText && (
                              <TextComponent
                                textValue={questionTextValueEnglish}
                                setTextValue={setQuestionTextValueEnglish}
                              />
                            )}
                            {isTypeQuestionLink && (
                              <LinkComponent
                                linkValue={questionLinkValueEnglish}
                                setLinkValue={setQuestionLinkValueEnglish}
                              />
                            )}
                          </div>
                        )}

                        {isQuestionType && (
                          <div className="col-md-12 col-sm-12">
                            <div className="col-md-12 col-sm-12">
                              <h6 id="editpanel">Hindi</h6>
                            </div>
                            {isTypeQuestionText && (
                              <TextComponent
                                textValue={questionTextValueHindi}
                                setTextValue={setQuestionTextValueHindi}
                              />
                            )}
                            {isTypeQuestionLink && (
                              <LinkComponent
                                linkValue={questionLinkValueHindi}
                                setLinkValue={setQuestionLinkValueHindi}
                              />
                            )}
                          </div>
                        )}

                        {isQuestionType && (
                          <div className="col-md-12 col-sm-12">
                            <div className="col-md-12 col-sm-12">
                              <h6 id="editpanel">Marathi</h6>
                            </div>
                            {isTypeQuestionText && (
                              <TextComponent
                                textValue={questionTextValueMarathi}
                                setTextValue={setQuestionTextValueMarathi}
                              />
                            )}
                            {isTypeQuestionLink && (
                              <LinkComponent
                                linkValue={questionLinkValueMarathi}
                                setLinkValue={setQuestionLinkValueMarathi}
                              />
                            )}
                          </div>
                        )}

                        <hr
                          style={{
                            margin: "20px 0",
                            borderTop: "1px solid #ccc",
                          }}
                        />
                        {isTrueFalse ? (
                          <>
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option A</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <input
                                type="text"
                                // onChange={(e) => setTagName(e.target.value)}
                                className="form-control"
                                // placeholder="Eg: traffic, rules"
                                value="TRUE"
                                disabled
                              />
                            </div>
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option B</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <input
                                type="text"
                                // onChange={(e) => setTagName(e.target.value)}
                                className="form-control"
                                // placeholder="Eg: traffic, rules"
                                value="FALSE"
                                disabled
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            {" "}
                            {/* Option A insert */}
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option A</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <div class="form-group">
                                <label for="selectInput">Option 1 Type</label>
                                <select
                                  class="custom-select form-select rounded-0"
                                  id="selectInput"
                                  onChange={(e) => {
                                    setOption1Type(e.target.value);
                                    onTypeChange(e.target.value, "O1");
                                  }}
                                  value={option1Type}
                                >
                                  <option value="" disabled selected>
                                    select type
                                  </option>
                                  {typeList.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {isOption1Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">English</h6>
                                </div>
                                {isTypeOption1Text && (
                                  <TextComponent
                                    textValue={option1TextValueEnglish}
                                    setTextValue={setOption1TextValueEnglish}
                                  />
                                )}
                                {isTypeOption1Link && (
                                  <LinkComponent
                                    linkValue={option1LinkValueEnglish}
                                    setLinkValue={setOption1LinkValueEnglish}
                                  />
                                )}
                              </div>
                            )}
                            {isOption1Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Hindi</h6>
                                </div>
                                {isTypeOption1Text && (
                                  <TextComponent
                                    textValue={option1TextValueHindi}
                                    setTextValue={setOption1TextValueHindi}
                                  />
                                )}
                                {isTypeOption1Link && (
                                  <LinkComponent
                                    linkValue={option1LinkValueHindi}
                                    setLinkValue={setOption1LinkValueHindi}
                                  />
                                )}
                              </div>
                            )}
                            {isOption1Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Marathi</h6>
                                </div>
                                {isTypeOption1Text && (
                                  <TextComponent
                                    textValue={option1TextValueMarathi}
                                    setTextValue={setOption1TextValueMarathi}
                                  />
                                )}
                                {isTypeOption1Link && (
                                  <LinkComponent
                                    linkValue={option1LinkValueMarathi}
                                    setLinkValue={setOption1LinkValueMarathi}
                                  />
                                )}
                              </div>
                            )}
                            <hr
                              style={{
                                margin: "20px 0",
                                borderTop: "1px solid #ccc",
                              }}
                            />
                            {/* Option B insert */}
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option B</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <div class="form-group">
                                <label for="selectInput">Option 2 Type</label>
                                <select
                                  class="custom-select form-select rounded-0"
                                  id="selectInput"
                                  onChange={(e) => {
                                    setOption2Type(e.target.value);
                                    onTypeChange(e.target.value, "O2");
                                  }}
                                  value={option2Type}
                                >
                                  <option value="" disabled selected>
                                    select type
                                  </option>
                                  {typeList.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {isOption2Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">English</h6>
                                </div>
                                {isTypeOption2Text && (
                                  <TextComponent
                                    textValue={option2TextValueEnglish}
                                    setTextValue={setOption2TextValueEnglish}
                                  />
                                )}
                                {isTypeOption2Link && (
                                  <LinkComponent
                                    linkValue={option2LinkValueEnglish}
                                    setLinkValue={setOption2LinkValueEnglish}
                                  />
                                )}
                              </div>
                            )}
                            {isOption2Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Hindi</h6>
                                </div>
                                {isTypeOption2Text && (
                                  <TextComponent
                                    textValue={option2TextValueHindi}
                                    setTextValue={setOption2TextValueHindi}
                                  />
                                )}
                                {isTypeOption2Link && (
                                  <LinkComponent
                                    linkValue={option2LinkValueHindi}
                                    setLinkValue={setOption2LinkValueHindi}
                                  />
                                )}
                              </div>
                            )}
                            {isOption2Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Marathi</h6>
                                </div>
                                {isTypeOption2Text && (
                                  <TextComponent
                                    textValue={option2TextValueMarathi}
                                    setTextValue={setOption2TextValueMarathi}
                                  />
                                )}
                                {isTypeOption2Link && (
                                  <LinkComponent
                                    linkValue={option2LinkValueMarathi}
                                    setLinkValue={setOption2LinkValueMarathi}
                                  />
                                )}
                              </div>
                            )}
                            <hr
                              style={{
                                margin: "20px 0",
                                borderTop: "1px solid #ccc",
                              }}
                            />
                            {/* Option C insert */}
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option C</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <div class="form-group">
                                <label for="selectInput">Option 3 Type</label>
                                <select
                                  class="custom-select form-select rounded-0"
                                  id="selectInput"
                                  onChange={(e) => {
                                    setOption3Type(e.target.value);
                                    onTypeChange(e.target.value, "O3");
                                  }}
                                  value={option3Type}
                                >
                                  <option value="" disabled selected>
                                    select type
                                  </option>
                                  {typeList.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {isOption3Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">English</h6>
                                </div>
                                {isTypeOption3Text && (
                                  <TextComponent
                                    textValue={option3TextValueEnglish}
                                    setTextValue={setOption3TextValueEnglish}
                                  />
                                )}
                                {isTypeOption3Link && (
                                  <LinkComponent
                                    linkValue={option3LinkValueEnglish}
                                    setLinkValue={setOption3LinkValueEnglish}
                                  />
                                )}
                              </div>
                            )}
                            {isOption3Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Hindi</h6>
                                </div>
                                {isTypeOption3Text && (
                                  <TextComponent
                                    textValue={option3TextValueHindi}
                                    setTextValue={setOption3TextValueHindi}
                                  />
                                )}
                                {isTypeOption3Link && (
                                  <LinkComponent
                                    linkValue={option3LinkValueHindi}
                                    setLinkValue={setOption3LinkValueHindi}
                                  />
                                )}
                              </div>
                            )}
                            {isOption3Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Marathi</h6>
                                </div>
                                {isTypeOption3Text && (
                                  <TextComponent
                                    textValue={option3TextValueMarathi}
                                    setTextValue={setOption3TextValueMarathi}
                                  />
                                )}
                                {isTypeOption3Link && (
                                  <LinkComponent
                                    linkValue={option3LinkValueMarathi}
                                    setLinkValue={setOption3LinkValueMarathi}
                                  />
                                )}
                              </div>
                            )}
                            <hr
                              style={{
                                margin: "20px 0",
                                borderTop: "1px solid #ccc",
                              }}
                            />
                            {/* Option D insert */}
                            <div className="col-md-12 col-sm-12">
                              <h3 id="editpanel">Option D</h3>
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <div class="form-group">
                                <label for="selectInput">Option 4 Type</label>
                                <select
                                  class="custom-select form-select rounded-0"
                                  id="selectInput"
                                  onChange={(e) => {
                                    setOption4Type(e.target.value);
                                    onTypeChange(e.target.value, "O4");
                                  }}
                                  value={option4Type}
                                >
                                  <option value="" disabled selected>
                                    select type
                                  </option>
                                  {typeList.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {isOption4Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">English</h6>
                                </div>
                                {isTypeOption4Text && (
                                  <TextComponent
                                    textValue={option4TextValueEnglish}
                                    setTextValue={setOption4TextValueEnglish}
                                  />
                                )}
                                {isTypeOption4Link && (
                                  <LinkComponent
                                    linkValue={option4LinkValueEnglish}
                                    setLinkValue={setOption4LinkValueEnglish}
                                  />
                                )}
                              </div>
                            )}
                            {isOption4Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Hindi</h6>
                                </div>
                                {isTypeOption4Text && (
                                  <TextComponent
                                    textValue={option4TextValueHindi}
                                    setTextValue={setOption4TextValueHindi}
                                  />
                                )}
                                {isTypeOption4Link && (
                                  <LinkComponent
                                    linkValue={option4LinkValueHindi}
                                    setLinkValue={setOption4LinkValueHindi}
                                  />
                                )}
                              </div>
                            )}
                            {isOption4Type && (
                              <div className="col-md-12 col-sm-12">
                                <div className="col-md-12 col-sm-12">
                                  <h6 id="editpanel">Marathi</h6>
                                </div>
                                {isTypeOption4Text && (
                                  <TextComponent
                                    textValue={option4TextValueMarathi}
                                    setTextValue={setOption4TextValueMarathi}
                                  />
                                )}
                                {isTypeOption4Link && (
                                  <LinkComponent
                                    linkValue={option4LinkValueMarathi}
                                    setLinkValue={setOption4LinkValueMarathi}
                                  />
                                )}
                              </div>
                            )}
                          </>
                        )}

                        <div className="col-md-12 col-sm-12"></div>
                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            {!isMatchFollowing && (
                              <label for="selectInput">Select Answer</label>
                            )}
                            {isTrueFalse ? (
                              <select
                                class="custom-select form-select rounded-0"
                                id="selectInput"
                                onChange={(e) => {
                                  setAnswerValue(e.target.value);
                                }}
                                value={answerValue}
                              >
                                <option value="" disabled selected>
                                  Select an option
                                </option>
                                {trueFalseAnswersList.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.value}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              !isMatchFollowing && (
                                <select
                                  class="custom-select form-select rounded-0"
                                  id="selectInput"
                                  onChange={(e) => {
                                    setAnswerValue(e.target.value);
                                  }}
                                  value={answerValue}
                                >
                                  <option value="" disabled selected>
                                    Select an option
                                  </option>
                                  {answersList.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              )
                            )}
                          </div>
                        </div>

                        <hr style={{ backgroundColor: "#434257c4" }} />

                        {mcqId == "" && (
                          <div className="row">
                            <div className="col-md-12 mt-4">
                              <Button
                                variant="contained"
                                color="primary"
                                startIcon={<StoreOutlined />}
                                onClick={() => handleSetButton()}
                              >
                                Set Questions
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>

                      {questions.length > 0 && (
                        <>
                          <hr
                            style={{
                              margin: "20px 0",
                              borderTop: "1px solid #ccc",
                            }}
                          />
                          <DisplayEnteredData
                            data={questions}
                            onDelete={handleDeleteQuestion}
                          />
                        </>
                      )}
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        {mcqId === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /.card */}
            </div>
            {/*/.col (right) */}
          </div>
          {/* /.row */}
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  {/* <div className="card-header">
                    <h4>Filter</h4>
                  </div> */}

                  {/* <form onSubmit={handleFilter} ref={formRef}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-sm-12">
                          <div class="form-group">
                            <div className="col-md-2 col-sm-12">
                              <label for="selectInput">
                                {mcqId === "" ? "Select" : "Edit"} Type For:
                              </label>
                            </div>
                            <div
                              className="col-md-10 col-sm-12"
                              style={{
                                display: "flex",
                                justifyContent: "space-start",
                                alignItems: "center",
                              }}
                            >
                              <label className="mcq-type-for">
                                <input
                                  type="radio"
                                  value="1"
                                  checked={filterSelectedTypeFor === "1"}
                                  onChange={(e) => {
                                    setFilterSlectedTypeFor(e.target.value);
                                    filterTypeOnChange(e.target.value);
                                  }}
                                />
                                MCQ
                              </label>

                              <label className="mcq-type-for">
                                <input
                                  type="radio"
                                  value="2"
                                  checked={filterSelectedTypeFor === "2"}
                                  onChange={(e) => {
                                    setFilterSlectedTypeFor(e.target.value);
                                    filterTypeOnChange(e.target.value);
                                  }}
                                />
                                Math
                              </label>

                              <label className="mcq-type-for">
                                <input
                                  type="radio"
                                  value="3"
                                  checked={filterSelectedTypeFor === "3"}
                                  onChange={(e) => {
                                    setFilterSlectedTypeFor(e.target.value);
                                    filterTypeOnChange(e.target.value);
                                  }}
                                />
                                Grammar
                              </label>
                              <br />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-1 col-sm-12"></div>

                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Select Board</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setBoardName(e.target.value);
                                setBoardNameFilter(e.target.value);
                                setLanguageName("");
                                setClassName("");
                                onBoardChange(e.target.value);
                              }}
                              required
                              value={boardNameFilter}
                              name="board_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {boardList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Select Language</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setLanguageName(e.target.value);
                                setLanguageNameFilter(e.target.value);
                                setClassName("");
                                onLanguageChange(e.target.value);
                              }}
                              required
                              value={languageNameFilter}
                              name="language_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {languageList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Select Class</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                setClassNameFilter(e.target.value);
                                // onClassChange(e.target.value)
                              }}
                              required
                              value={classNameFilter}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-1 col-sm-12 d-flex justify-content-center align-items-center">
                          <button type="submit" className="btn btn-primary">
                            Filter
                          </button>
                        </div>

                        <div className="col-md-1 col-sm-12"></div>
                      </div>
                    </div>
                  </form> */}

                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Questions"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute(
                            "download",
                            "questions.csv"
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("questions.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        //   {
                        //     icon: () => (
                        //       <span style={{ color: "#5656ce" }}>
                        //         <Add />
                        //       </span>
                        //     ),
                        //     tooltip: "Add",
                        //     onClick: (event, rowData) => handleEdit(rowData),
                        //   },
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                          // viewSetQuestions(rowData.id),
                        }),
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Visibility />
                            </span>
                          ),
                          tooltip: "View",
                          onClick: (event, rowData) => viewData(rowData),
                          // viewSetQuestions(rowData.id),
                        }),
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Delete />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleDelete(rowData.id),
                        }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Questions;
